import React from 'react';
import './custom-switch-button.scss';

interface SwitchProperties {
  /** The type of input element to render */
  type?: 'checkbox' | 'radio';
  /** The checked state of the switch */
  checked?: boolean;
  /** Callback function triggered when the switch state changes */
  change?: (checked: boolean) => void;
}

/**
 * Custom Switch Component
 * @param {any} param0 properties
 * @param {any} param0.type type
 * @param {any} param0.checked checked
 * @param {any} param0.change change callback
 * @returns {any} switch button
 */
function CustomSwitchButton({
  type = 'checkbox',
  checked = false,
  change = () => {},
}: SwitchProperties) {
  // Generate a unique ID for accessibility
  const inputId = `switch-${Math.random().toString(36).substr(2, 9)}`;
  return (
    <label className="switch" htmlFor={inputId}>
      <input
        id={inputId}
        type={type}
        checked={checked}
        onChange={(event) => change(event.target.checked)}
        aria-label="Switch input"
      />
      <span className="slider" />
    </label>
  );
}

/**
 * Default properties for the Switch component.
 * Provides default values for optional props to ensure component functionality
 * when not all props are specified.
 */
CustomSwitchButton.defaultProps = {
  type: 'checkbox',
  checked: false,
  /**
   * Callback function triggered when the switch state changes.
   * This default is an empty function, but can be overridden by providing
   * a custom function in the `change` prop.
   */
  change: () => {},
};

export default CustomSwitchButton;
